import { render } from "./ChevronLeftIcon.vue?vue&type=template&id=aeb64fd4"
import script from "./ChevronLeftIcon.vue?vue&type=script&lang=js"
export * from "./ChevronLeftIcon.vue?vue&type=script&lang=js"
script.render = render

export default script